import { useEffect} from 'react'
import React from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import ran1 from '../Assets/ran1.webp';
import ran2 from '../Assets/ran2.webp';
import looper from '../Assets/LooperGroup.webp';
import looperflipped from '../Assets/LooperGroupFlipped.webp';
import gdrive from '../Assets/gdrive.webp';
import { Link } from 'react-router-dom';

export default function LastYear() {
    useEffect(() => {
      /**
       * Server-side rendering does not provide the 'document' object
       * therefore this import is required either in useEffect or componentDidMount as they
       * are exclusively executed on a client
       */
      const AOS = require("aos");
      AOS.init({
        once: true,
      });
    }, []);
  
    useEffect(() => {
      if (AOS) {
        AOS.refresh();
      }
    });
    
    return(
        <div className="mt-24 lg:mt-48 mb-12">
            <div>
                <h1 className="font-[BebasNeue] text-transparent bg-clip-text bg-gradient-to-bl from-white drop-shadow-[0_10px_5px_rgba(0,0,0,10)] text-4xl lg:text-9xl lg:ml-24 ml-10 z-10 relative -mb-2 lg:mb-3"
                data-aos="fade-right"
                data-aos-offset="300"
                data-aos-duration="1000"
                data-aos-delay="0">LAST YEAR'S</h1>
                <h1 className="font-[BebasNeue] text-transparent bg-clip-text bg-gradient-to-bl from-white drop-shadow-[0_10px_5px_rgba(0,0,0,10)] text-4xl lg:text-9xl lg:ml-24 ml-10 z-20 relative -mb-5 lg:-mt-10"
                data-aos="fade-right"
                data-aos-offset="300"
                data-aos-duration="1000"
                data-aos-delay="0">SMAKONECUP</h1>
                <div className=""
                data-aos="fade-right"
                data-aos-offset="300"
                data-aos-duration="1000"
                data-aos-delay="0">
                    <Link to="https://drive.google.com/drive/u/0/folders/1qe0OyVc7c16VZmvLeEf5sxXFSY4daOLy" target="_blank"><p className="border border-white rounded-lg text-white px-3 pb-2 pt-1 lg:px-7 lg:pb-3 justify-center flex lg:pt-5 lg:translate-y-4 lg:ml-24 backdrop-blur-lg bg-slate-100 bg-opacity-60 w-fit font-[JakartaSansBold] text-white text-center text-base lg:text-3xl lg:rounded-xl ml-10 z-20 relative translate-y-6 hover:shadow-white hover:shadow-[0_0px_60px_-8px_rgba(0,0,0,0.3)]"><span className="inline-flex items-baseline"><img src={gdrive} className="w-6 lg:w-12 mx-1 self-center translate-y-1.5 lg:-translate-y-1"/></span>Our memories</p></Link>
                </div>
                <div className="ml-36 w-56 lg:w-[35rem] -mt-24 lg:-mt-[19rem] lg:ml-[34rem] -translate-y-2 z-0 relative"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-duration="1000"
                data-aos-delay="0">    
                    <img src={ran1} className="rounded-md lg:rounded-xl"/>
                </div>
                <div className="w-[22rem] lg:w-[59rem] lg:-mt-[33rem] lg:ml-[16rem] relative z-10"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-duration="1000"
                data-aos-delay="0">
                    <img src={ran2} className="ml-16 -mt-[12.7rem]"/>
                </div>
                <div>
                    <img src={looper} className="lg:block hidden ml-44 -mt-48 relative -z-10 lg:ml-[39rem] lg:-mt-[35rem]"
                    data-aos="fade-left"
                    data-aos-offset="300"
                    data-aos-duration="1000"
                    data-aos-delay="0"/>
                    <img src={looperflipped} className="lg:block hidden -mt-[28rem] ml-44 -z-10 lg:-mt-[80rem] lg:ml-[39rem]"
                    data-aos="fade-left"
                    data-aos-offset="300"
                    data-aos-duration="1000"
                    data-aos-delay="0"/>
                </div>
            </div>
        </div>
    )
}